import { z } from 'zod'

const PlanBuyoutReasonEnum = z.enum(['plan.buyout.claim_submitted', 'plan.buyout.claim_approved'])

export const planBuyoutDetailsSchema = z.object({
  canBeBoughtOut: z.boolean(),
  reason: PlanBuyoutReasonEnum.nullable().optional().catch(null), // don't require enum entry for reason with no FE functionality
  evidenceSessionId: z.string().nullable().optional(),
  showAlert: z.boolean(),
})

export type PlanBuyoutDetails = z.infer<typeof planBuyoutDetailsSchema>
